import ApiService from '../index'

export const condominiums = async (query) => {
  const URI = `/api/condominium?${new URLSearchParams(query)}`

  const response = await ApiService.get(URI)

  return response.data
}

export const deleteCondominium = async (id) => {
  const URI = `/api/condominium/${id}`

  const response = await ApiService.delete(URI)

  return response
}

export const toggleStatus = async (id) => {
  const URI = `/api/condominium/desative/${id}`

  const response = await ApiService.post(URI, {})

  return response
}

export const addCondominium = async (condominium) => {
  const URI = `/api/condominium`

  const response = await ApiService.post(URI, condominium)

  return response.data
}

export const updateCondominium = async (condominium) => {
  const URI = `/api/condominium/${condominium.id}`

  const response = await ApiService.patch(URI, condominium)

  return response.data
}

export const logsCondominium = async (id, minDate = '', maxDate = '', changedDate = '') => {
  const URI = `/api/audit?product_id=${id}&product=condominiums&min_date=${minDate}&max_date=${maxDate}&changed_date=${changedDate}`

  const response = await ApiService.get(URI)

  return response.data
}

export const getDatasheetCondominium = async (id) => {
  const URI = `api/technicalPlug?condominium_id=${id}`

  const response = await ApiService.get(URI)

  return response.data
}

export const saveDatasheetCondominium = async (payload, id) => {
  const URI = `api/technicalPlug?condominium_id=${id}`

  const response = await ApiService.post(URI, payload)

  return response.data
}


export const toggleChecklistStatus = async (payload) => {
  const URI = `api/checklist/jobs/condominium`

  const response = await ApiService.put(URI, payload)

  return response.data
}


export const getChecklist = async (condominiumId) => {
  const URI = `api/checklist/jobs/condominium?condominium_id=${condominiumId}`

  const response = await ApiService.get(URI)

  return response.data
}